var map = {
	"./calculator.png": 667,
	"./doc.png": 417,
	"./drum-machine.png": 95,
	"./landing_page.png": 294,
	"./markdown.png": 936,
	"./memory_game.png": 225,
	"./pomodoro.png": 462,
	"./product.png": 190,
	"./quotes.png": 508,
	"./restaurant.png": 966,
	"./resume_builder.png": 426,
	"./rockpaperscissors.png": 473,
	"./shop.png": 943,
	"./sign_up_form.png": 481,
	"./survey.png": 657,
	"./todolist.png": 451,
	"./tribute.png": 854,
	"./weather.png": 199,
	"./wikipedia.png": 278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;